import { Control, Controller, FieldPath, FieldValues } from 'react-hook-form'

import FormGroup from '../../../../core/components/FormGroup'
import { ColorPicker } from '@/components/ui'
import type { ColorFormat } from '@/components/ui/color-picker'

export interface ColorFieldProps<T extends FieldValues> {
  control: Control<T>
  name: FieldPath<T>
  label?: string
  error?: string
  disabled?: boolean
  format?: ColorFormat
}

export function ColorField<T extends FieldValues>({
  control,
  name,
  label,
  error,
  disabled,
  format,
}: ColorFieldProps<T>) {
  return (
    <FormGroup label={label} error={error}>
      <Controller
        name={name}
        control={control}
        render={({ field }) => (
          <ColorPicker
            {...field}
            isInvalid={!!error}
            disabled={disabled}
            format={format}
          />
        )}
      />
    </FormGroup>
  )
}
